import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const QuestionSpeechBubble = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 23"
      style={style}
    >
      <path d="M21.05,0c1.634,0.026 2.95,1.33 2.95,2.935l0,11.88c-0.022,1.347 -0.971,2.473 -2.25,2.795l0,4.195c-0.02,0.663 -0.571,1.195 -1.25,1.195c-0.306,0 -0.602,-0.11 -0.83,-0.31l-5.704,-4.987l-11.016,0c-1.634,-0.028 -2.95,-1.331 -2.95,-2.937l0,-11.879c0.027,-1.599 1.36,-2.887 3,-2.887l18.05,0Zm-0.05,1.475l-18.038,0c-0.81,0.02 -1.462,0.669 -1.462,1.466l0,11.859c0.02,0.792 0.684,1.428 1.5,1.428l11.74,0l0.135,0.123l0.002,0l5.373,4.873l0,-4.996l0.788,0c0.81,-0.02 1.462,-0.669 1.462,-1.466l0,-11.858c-0.02,-0.792 -0.684,-1.429 -1.5,-1.429Zm-3.48,4.057c0.627,0 1.114,0.146 1.46,0.44c0.347,0.295 0.52,0.71 0.52,1.246c0,0.244 -0.057,0.474 -0.169,0.69c-0.106,0.205 -0.289,0.432 -0.547,0.68l-0.043,0.04l-0.36,0.332c-0.214,0.2 -0.34,0.431 -0.381,0.696l-0.005,0.04l-0.018,0.262c-0.076,0.326 -0.269,0.489 -0.578,0.489c-0.308,0 -0.495,-0.163 -0.559,-0.49c0,-0.401 0.051,-0.72 0.152,-0.958c0.094,-0.225 0.264,-0.446 0.509,-0.665l0.118,-0.104c0.226,-0.2 0.38,-0.367 0.46,-0.498c0.089,-0.145 0.133,-0.298 0.133,-0.458c0,-0.485 -0.23,-0.728 -0.692,-0.728c-0.22,0 -0.394,0.065 -0.526,0.196c-0.124,0.123 -0.193,0.29 -0.205,0.5c-0.08,0.327 -0.3,0.49 -0.656,0.49c-0.357,0 -0.568,-0.15 -0.633,-0.45c0.006,-0.547 0.188,-0.976 0.548,-1.285c0.36,-0.31 0.85,-0.465 1.472,-0.465Zm-5.195,5.194c0.365,0 0.661,0.29 0.661,0.65c0,0.358 -0.296,0.649 -0.66,0.649l-7.196,0c-0.366,0 -0.662,-0.291 -0.662,-0.65c0,-0.358 0.296,-0.649 0.662,-0.649l7.195,0Zm0,-2.597c0.365,0 0.661,0.29 0.661,0.65c0,0.358 -0.296,0.649 -0.66,0.649l-7.196,0c-0.366,0 -0.662,-0.291 -0.662,-0.65c0,-0.358 0.296,-0.649 0.662,-0.649l7.195,0Zm5.175,2.69c0.345,0 0.625,0.274 0.625,0.614c0,0.34 -0.28,0.615 -0.625,0.615c-0.345,0 -0.625,-0.276 -0.625,-0.615c0,-0.34 0.28,-0.615 0.625,-0.615l0,0.001Zm-5.175,-5.287c0.365,0 0.661,0.29 0.661,0.65c0,0.358 -0.296,0.649 -0.66,0.649l-7.196,0c-0.366,0 -0.662,-0.291 -0.662,-0.65c0,-0.358 0.296,-0.649 0.662,-0.649l7.195,0Z" />
    </svg>
  );
};

QuestionSpeechBubble.defaultProps = {
  width: '100%',
  height: '100%',
  style: {},
};

export default QuestionSpeechBubble;
